/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const FILE_EXPLORER_STRINGS = {
  actions: 'Actions',
  applyChanges: 'Apply changes',
  cancel: 'Cancel',
  cascadePermission: 'Cascade permission',
  changeSelectedPermissions: 'Change selected files permissions.',
  changeSinglePermission: 'Change item permission.',
  close: 'Close',
  confirm: 'Confirm',
  copy: 'Copy',
  create: 'Create',
  createFolder: 'Create folder',
  delete: 'Delete',
  deleteFilesFolders: 'Delete folders/files',
  deleteItemsDialogText: 'Are you sure you want to delete {{count}} item(s)?',
  directoryIsEmpty: 'Directory is empty',
  download: 'Download',
  dragAndDropArea: 'Drag and drop area for files',
  dropFilesHere: 'Drop files here',
  extension: 'Extension',
  extract: 'Extract',
  extractArchive: 'Extract archive',
  extractErrorNotEmpty: 'The chosen directory has existing files, please select an empty directory',
  file: 'File',
  fileActions: 'File actions',
  fileFolderId: 'File / Folder ID',
  fileSize: 'File size',
  folder: 'Folder',
  folderName: 'Folder name',
  followingFilesNotDeleted:
    'The following files and folders have not been deleted and are still present in the directory:',
  information: 'Information',
  itemsSetToPrivate: 'file(s)/folder(s) are currently set to Private',
  itemsSetToPublic: 'file(s)/folder(s) are currently set to Public',
  lastUpdated: 'Last updated',
  mixedPermissionsWarning: 'The selected files/folders have mixed permission settings:',
  move: 'Move',
  name: 'Name',
  ok: 'OK',
  permissions: 'Permissions',
  private: 'Private',
  privatePermissionDescription:
    'All selected files and folders will be made private. Only authorized users with the necessary permissions can access these files/folders.',
  public: 'Public',
  publicPermissionDescription:
    'All selected files and folders will be made publicly accessible.  Anyone with the link can view and download these files/folders.',
  remainingItems: 'Remaining items',
  rename: 'Rename',
  selectDirectoryToUnarchive: 'Select an empty directory in which to extract the archive.',
  showFileId: 'Show ID',
  singleFilePrivatePermissionDescription:
    'This item will be made private. Only authorized users with the necessary permissions can access this file/folder.',
  singleFilePublicPermissionDescription:
    'This item will be made publicly accessible. Anyone with the link can view and download this file/folder.',
  size: 'Size',
  type: 'Type',
  uploadFiles: 'Upload files',
  url: 'URL',
  virusDeleteWarning: 'Files or folders that fail a scan will be automatically deleted in 48 hours.',
  virusDeleteWarningBold: 'scans failed',
  virusScan: 'Virus scan status',
  virusStatusQuarantined: 'Quarantined',
  virusStatusScanned: 'Scanned',
  virusStatusUnknown: 'Unable to scan',
  virusStatusUnscanned: 'Unscanned',
  visibility: 'Visibility',
};
